import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=66824866&"
import script from "./error-content.vue?vue&type=script&lang=js&"
export * from "./error-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "error-content.vue"
export default component.exports